// extracted by mini-css-extract-plugin
module.exports = {"mySwiper":"styleSwipper_mySwiper__Oj_Az","swiperitem":"styleSwipper_swiperitem__LZDJB"};